import { extendComponent } from "@eusoft/webapp-core";
import { ItemEditContent } from "@eusoft/webapp-framework";
import { ObjectEditor, required } from "@eusoft/webapp-ui";
import { AddressEditor } from "../../components/AddressEditor";
import { Authorize } from "../../services/Authorize";
import type { ICreateMerchant } from "../../entities/Commands";


export const MerchantEditor = extendComponent(ObjectEditor<ICreateMerchant>, {}, {

    commitMode: "manual",
    style: "vertical",
    name: "merchant-editor",
    inputField: { style: "filled" },

    builder: bld => <>

        {bld.text(a => a.name, {
            validators: [required]
        })}

        {bld.text(a => a.companyName, {
            validators: [required]
        })}

        {bld.text(a => a.taxCode, {
            validators: [required]
        })}

        {bld.editor(a => a.billAddress, AddressEditor, {
            style: ["vertical-label", "no-box", "no-error"],
            validators: [required],
            editor: {
                inputField: { style: "filled" },
            }
        })}
    </>
} )


export const CreateMerchantPage = ItemEditContent.bulder<ICreateMerchant>()

    .feature(Authorize(a => a.businessAccount()
        .resource("Merchant", "create")
    ))

    .info({
        name: "merchant-create",
        route: "/merchant/create",
    })

    .options({

        title: "create-merchant",
        style: ["panel"],

        createEditor: () => new MerchantEditor(null),

        onLoadArgsAsync: async args => {

            args.value = {} as ICreateMerchant;
            return true;
        },

        onSaveAsync: async value => {

            return true;
        }

    }).asContent(); 